(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProductCategoryProduct', ProductCategoryProduct);

    ProductCategoryProduct.$inject = ['$resource'];

    function ProductCategoryProduct ($resource) {
        var resourceUrl =  'api/product-category-products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
